module.exports = __webpack_public_path__ + "img/lv9.00b7e2dd.png";